import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Typography, Box } from 'transfix-ui/core'
import { ReactComponent as EmailCheck } from 'apps/fleet-planner/components/illustrations/onboarding/EmailCheck.svg'
import { getRoute } from 'apps/fleet-planner/constants'
import { useOnboardingWizardContext } from 'apps/fleet-planner/context'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import { OnboardingStepContainer } from './OnboardingStepContainer'

export const OnboardingStepCheckEmail = () => {
  const { trackEvent } = useFMSAnalytics()
  const { mobileApp, userEmail = '' } = useOnboardingWizardContext()

  useEffect(() => {
    trackEvent('Onboarding', 'ONBOARDING_VIEWED_CHECK_YOUR_EMAIL_PAGE')
  }, [trackEvent])

  return (
    <>
      <OnboardingStepContainer maxWidth={424} fadeIn>
        <Box mb={3} textAlign='center'>
          {/* Offset centers the envelope illustration */}
          <Box marginRight='-22px'>
            <EmailCheck />
          </Box>
        </Box>
        <Box mb={4} textAlign='center'>
          <Typography variant='h3' component='div'>
            Check your email
          </Typography>
        </Box>
        <Box mb={3}>
          <Typography variant='body1' component='div'>
            We sent a verification email to <strong>{userEmail}</strong> with a link to verify your
            account.
          </Typography>
        </Box>
        <Box mb={2}>
          <Typography variant='subtitle2' component='div'>
            Didn’t get an email?
          </Typography>
        </Box>
        <Box mb={2}>
          <Typography variant='body2' component='div'>
            If you don’t see an email from us within a few minutes, a few things could have
            happened:
          </Typography>
        </Box>
        <Box mb={2}>
          <ul>
            <li>
              <Typography variant='body2' component='span'>
                The email is in your spam folder.
              </Typography>
            </li>
            <li>
              <Typography variant='body2' component='span'>
                The email address you entered had a mistake or typo.
              </Typography>
            </li>
            <li>
              <Typography variant='body2' component='span'>
                We can’t deliver the email to this address. (Usually because of corporate firewalls
                or filtering.)
              </Typography>
            </li>
          </ul>
        </Box>
        {!mobileApp && (
          <Typography variant='body2' component='div'>
            <Box>
              <Link to={getRoute('emailInput')}>Enter another email address</Link>
            </Box>
          </Typography>
        )}
      </OnboardingStepContainer>
    </>
  )
}
